import { render } from "./passengerOccupany.vue?vue&type=template&id=0281febf"
import script from "./passengerOccupany.vue?vue&type=script&lang=js"
export * from "./passengerOccupany.vue?vue&type=script&lang=js"

import "./passengerOccupany.vue?vue&type=style&index=0&id=0281febf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__